import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { User } from "../model/user.model";
import { Payment } from "../model/payment.model";
import { Feedback } from "../model/feedback.model";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class DlaService {
  loggedIn = false;
  authToken = "";
  user: any = "";

  //readonly mainURL = "http://localhost/dlabackend/api/";
  // readonly mainURL = "https://dlabackend.hezedge.com/api/";
  readonly mainURL = "https://daystarng.org/dlatestback/api/";
  //readonly mainURL = 'https://testbed.dlaonline.org/api/';
  //readonly mainURL = "https://dlabackend.daystarng.org/api/";
  readonly dccMainURL = "https://mobile.daystarng.org/api/";

  constructor(private http: HttpClient) {}

  registerUser(user: any) {
    const endPoint = "register";

    return this.http
      .post(this.mainURL + endPoint, user, httpOptions)
      .pipe(catchError(this.handleError));
  }

  loginUser(email: string, password: string) {
    const body = {
      email,
      password,
    };
    const endPoint = "login";

    return this.http
      .post(this.mainURL + endPoint, body, httpOptions)
      .pipe(catchError(this.handleError));
  }

  activateAccount(bspoke: string, grad: string) {
    const body = {
      bspoke,
      grad,
    };
    const endPoint = "activateAccount";

    return this.http
      .post(this.mainURL + endPoint, body, httpOptions)
      .pipe(catchError(this.handleError));
  }

  forgotPassword(email: string) {
    const body = {
      email,
    };
    const endPoint = "resetPassword";

    return this.http
      .post(this.mainURL + endPoint, body, httpOptions)
      .pipe(catchError(this.handleError));
  }

  resetPassword(userId: string, password: string, token: string) {
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };
    const body = {
      userId,
      password,
    };
    const endPoint = "changePassword";

    return this.http
      .post(this.mainURL + endPoint, body, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  updateProfile(user: User) {
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "updateProfile";

    return this.http
      .post(this.mainURL + endPoint, user, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getCurrentSessions() {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getCurrentSessions";

    return this.http
      .get(this.mainURL + endPoint, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getCurrentSessionForCoupon() {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json"
      }),
    };

    const endPoint = "getCurrentSessionForCoupon";

    return this.http
      .get(this.mainURL + endPoint, customHttpOptions)
      .pipe(catchError(this.handleError));
  }


  processCoupon(payload: any) {
    const endPoint = "processCoupon";

    return this.http
      .post(this.mainURL + endPoint, payload, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSessionAndTimeTable(session_id: string, user_id: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    console.log("Session_id in service : " + session_id);
    console.log("User_id in service : " + user_id);

    const endPoint = "getSessionAndTimeTable/" + session_id + "/" + user_id;

    console.log(endPoint);
    return this.http
      .get(this.mainURL + endPoint, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getInbox(user_id: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getInboxMessages";

    return this.http
      .post(this.mainURL + endPoint, { userId: user_id }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getSentMessage(user_id: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getSentMessages";

    return this.http
      .post(this.mainURL + endPoint, { userId: user_id }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  updateMessageReadStatus(messageId: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "updateMessageReadStatus";

    return this.http
      .post(
        this.mainURL + endPoint,
        { messageId: messageId },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  replyMessage(subject: string, body: string, messageId: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "replyMessage";

    return this.http
      .post(
        this.mainURL + endPoint,
        { subject: subject, body: body, messageId: messageId },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  sendMessage(
    subject: string,
    body: string,
    userId: string,
    recipientId: string
  ) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "sendMessage";

    return this.http
      .post(
        this.mainURL + endPoint,
        {
          subject: subject,
          body: body,
          recipientId: recipientId,
          senderId: userId,
        },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getRecipients(userType: string, userId: string, sessions: any) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getRecipents";

    return this.http
      .post(
        this.mainURL + endPoint,
        { userId: userId, userType: userType, sessions: sessions },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getSingleMail(type: string, mailId: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getMail";

    return this.http
      .post(
        this.mainURL + endPoint,
        { type: type, mailId: mailId },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getForumTopics() {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getForumTopics";

    return this.http
      .post(this.mainURL + endPoint, {}, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getForumDetails(forumId: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getForumDetails";

    return this.http
      .post(this.mainURL + endPoint, { forumId: forumId }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  submitViewForum(forumId: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "submitViewForum";

    return this.http
      .post(this.mainURL + endPoint, { forumId: forumId }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  submitLikeForum(forumId: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "submitLikeForum";

    return this.http
      .post(this.mainURL + endPoint, { forumId: forumId }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  submitForumComment(forumId: string, userId: string, post: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "submitForumComment";

    return this.http
      .post(
        this.mainURL + endPoint,
        { forumId: forumId, userId: userId, post: post },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  makeOfflinePayment(payment: Payment) {
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "makeOfflinePayment";

    return this.http
      .post(this.mainURL + endPoint, payment, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  makeCouponPayment(payment: Payment) {
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "makeCouponPayment";

    return this.http
      .post(this.mainURL + endPoint, payment, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  makeOnlinePayment(payment: Payment) {
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "makeOnlinePayment";

    return this.http
      .post(this.mainURL + endPoint, payment, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  makeDonation(payment: Payment) {
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "makeDonation";

    return this.http
      .post(this.mainURL + endPoint, payment, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getSessionHistory(user_id: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getSessionHistory";

    return this.http
      .post(this.mainURL + endPoint, { userId: user_id }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getTransactionHistory(user_id: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getTransactionHistory";

    return this.http
      .post(this.mainURL + endPoint, { userId: user_id }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  getFeedbackQuestions(user_id: string) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "getFeedbackQuestions";

    return this.http
      .post(this.mainURL + endPoint, { userId: user_id }, customHttpOptions)
      .pipe(catchError(this.handleError));
  }

  submitFeedback(userId: string, feedbacks: Feedback[]) {
    // console.log('Auth Token  in Service', this.authToken);
    const customHttpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authToken,
      }),
    };

    const endPoint = "submitFeedback";

    return this.http
      .post(
        this.mainURL + endPoint,
        { userId: userId, feedbacks: feedbacks },
        customHttpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getIpAddress() {
    return this.http
      .get("https://api.ipify.org/?format=json")
      .pipe(catchError(this.handleError));
  }

  getLatestSliders() {
    const endPoint = "getAnnouncements";

    return this.http
      .get(this.dccMainURL + endPoint, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError("Something bad happened; please try again later.");
  }
}
